import { useMediaQuery } from '@hooks/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import React, { useMemo } from 'react';

function DRCardWrapper({ children, isItemSelected }) {
    const isBelow1600 = useMediaQuery(`(max-width: 1600px)`);
    const isBelow1350 = useMediaQuery(`(max-width: 1350px)`);

    const lg = useMemo(
        () => (isBelow1600 && isItemSelected ? (isBelow1350 ? 6 : 4) : 3),
        [isBelow1600, isItemSelected, isBelow1350],
    );

    const md = useMemo(() => (isItemSelected ? 6 : 4), [isItemSelected]);

    return (
        <Grid xs={12} sm={6} md={md} lg={lg} item>
            {children}
        </Grid>
    );
}
export default DRCardWrapper;
